
angular.module('bmsApp.employee').controller('EmployeeViewCtrl', [
	'$scope',
	'$state',
	'notify',
	'ActivitySvc',
	'NoteSvc',
	'EmployeeSvc',
	'TrainingRecordSvc',
	'EmployeeAttendanceRecordSvc',
	'EmployeeEmergencyDetailSvc',
	'ReminderSvc',
	'ngTableParams',
	'SharedTrainingSvc',
	'$modal', function (
		$scope,
		$state,
		notify,
		ActivitySvc,
		NoteSvc,
		EmployeeSvc,
		TrainingRecordSvc,
		EmployeeAttendanceRecordSvc,
		EmployeeEmergencyDetailSvc,
		ReminderSvc,
		ngTableParams,
		SharedTrainingSvc,
		$modal) {

		$scope.note = {
			api: {}
		};

		$scope.addEvent = function () {
			$scope.events.events.push({
				title: 'new event',
				date: new Date()
			});
		};
		$scope.clearEvents = function () {
			$scope.events.events.splice(0, $scope.events.events.length);
		};

		employeeId = $state.params.employeeId;

		$scope.employee = {};

		$scope.deleteEmergencyContactConfirm = function (id) {
			EmployeeEmergencyDetailSvc.delete(id)
				.then(function (response) {
					notify({
						message: 'Emergency details deleted successfully'
					});
					$scope.tabEmergency(true);
				});
		};

		$scope.tabHoliday = function() {
			$scope.tabsActive.holidays = true;
		};

		$scope.tabTrainingRecords = function () {
			$scope.trainingRecords = new ngTableParams(angular.extend({
				page: 1, // show first page
				count: $scope.config.tabbedTable.params.count, // count per page
				sorting: {
					start_date: 'desc' // initial sorting
				}
			}), {
				total: 0, // length of data
				counts: $scope.config.tabbedTable.settings.counts, // available page counts
				getData: function ($defer, params) {
					TrainingRecordSvc.byEmployee(employeeId, params.$params)
						.then(function (response) {
							$scope.trainingRecordTotal = response.data.training_record_total_count;
							params.total(response.data.training_record_filtered_count);
							$defer.resolve(response.data.training_record_collection);
						});
				}
			});
		};

		$scope.tabSMTrainingRecords = function () {
			$scope.smTrainingRecords = new ngTableParams(angular.extend({
				page: 1, // show first page
				count: $scope.config.tabbedTable.params.count, // count per page
				sorting: {
					completed_at: 'desc' // initial sorting
				},
				filter: {
					employee: employeeId,
					employeeCompleted: true,
				}
			}), {
				total: 0, // length of data
				counts: $scope.config.tabbedTable.settings.counts, // available page counts
				getData: function ($defer, params) {
					SharedTrainingSvc.index(params.$params)
						.then(function (response) {
							$scope.smTrainingRecordTotal = response.data.count;
							params.total(response.data.count);
							$defer.resolve(response.data.course_collection);
						});
				}
			});
		};

		$scope.tabAttendance = function () {
			$scope.employeeAttendanceRecords = new ngTableParams(angular.extend({
				page: 1, // show first page
				count: $scope.config.tabbedTable.params.count, // count per page
				sorting: {
					date: 'desc' // initial sorting
				}
			}), {
				total: 0, // length of data
				counts: $scope.config.tabbedTable.settings.counts, // available page counts
				getData: function ($defer, params) {
					EmployeeAttendanceRecordSvc.byEmployee(employeeId, params.$params)
						.then(function (response) {
							$scope.attendanceRecordTotal = response.data.employee_attendance_record_total_count;
							params.total(response.data.employee_attendance_record_filtered_count);
							$defer.resolve(response.data.employee_attendance_record_collection);
						});
				}
			});
		};

		$scope.tabEmergencyLoaded = false;
		$scope.tabEmergencyLoading = true;
		$scope.tabEmergency = function (force) {
			if ($scope.tabEmergencyLoaded === false || force === true) {
				$scope.tabEmergencyLoading = true;
				EmployeeEmergencyDetailSvc.byEmployee($scope.employee.id)
					.then(function (response) {
						$scope.tabEmergencyLoaded = true;
						$scope.tabEmergencyLoading = false;
						$scope.employeeEmergencyDetails = response.data.employee_emergency_details;
					});
			}
		};

		$scope.tabNotes = function () {
			$scope.note.api.showNotes();
		};

		$scope.readEmployee = function () {
			$scope.loading = true;
			EmployeeSvc.read(employeeId)
				.then(function (response) {
					$scope.employee = response.data.employee;
					$scope.employee.profilePic = ($scope.employee.gender == 'Male') ? 'images/employees/silhouette-male.png' : 'images/employees/silhouette-female.png';
					$scope.loading = false;
				}, function (error) {
					$scope.loading = false;
				});
		};

		$scope.addEmergencyContactForm = function (employeeEmergencyDetailId) {

			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/employee/employeeEmergencyDetail/templates/employeeEmergencyDetailSave.html',
				controller: 'EmployeeAddEmergencyContactModalCtrl',
				size: 'lg',
				scope: $scope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					employeeEmergencyDetailId: function () {
						if (employeeEmergencyDetailId) {
							return employeeEmergencyDetailId;
						}
						else {
							return null;
						}
					}
				}
			});

			modalInstance.result.then(function (modalStatus) {
				if (modalStatus.success) {
					$scope.tabEmergency(true);
				}
			}, function () {
				// closed
			});

		};

		$scope.readEmployee();

		// Action menu links

		$scope.addActivity = function () {
			// empty activity with this employee pre-selected
			var activity = {
				employee: $scope.employee
			};
			ActivitySvc.showSaveModal(activity);
		};

		$scope.addNote = function () {
			var note = {
				object_type: 'App\\Models\\Employees\\Employee',
				object_id: $scope.employee.id
			};
			NoteSvc.showSaveModal(note);
		};

		$scope.$on('notesUpdated', function () {
			setActiveTab('notes');
		});

		$scope.tabsActive = {
			workHistory: $scope.isMM() ? true : false,
			training: $scope.isMM() ? false : true,
			attendance: false,
			holidays: false,
			additionalPayments: false,
			emergencyContacts: false,
			notes: false
		};

		// tab functions to be inherited and overridden by child controllers
		$scope.tabs = {
			workHistory: {
				select: function () {},
				reload: function () {}
			},
			additionalPayments: {
				select: function () {},
				reload: function () {}
			}
		};

		var setActiveTab = function (name) {
			angular.forEach($scope.tabsActive, function (value, key) {
				$scope.tabsActive[key] = String(key) === name;
			});
		};

		$scope.showReminderModal = function () {
			ReminderSvc.showReminderModal('Employee', $scope.employee.id);
		};

	}]);
